import { useEffect, useState } from "react";
import { _AdquisitionItem, _EcmDocument, _JobRequisition, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../../editor/AccountEditor";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../theme/Component/PrintJson";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    IDAccount: number;
    Obs: string
}

export const SCVA002 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_JobRequisition)


    const [response, setResponse] = useState<Partial<Resp>>({
        IDAccount: null
    })

    const props = configProcedure?._pocessData?.Props ?? {};
    const procedure = configProcedure?._procedure ?? {};


    useEffect(() => {
        if (props?.IDJobRequisition) {
            instance.getJobRequisition(props?.IDJobRequisition).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo Cargar la informacion de la solicitud, intentelo mas tarde") })
        }
    }, [props?.IDJobRequisition])


    const onExportMap = () => {

        instance.updateJobRequisition({ ...bean, IDAccount: response?.IDAccount }).then(
            (resp) => {
                if (configProcedure?._pushInfo) {
                    configProcedure?._pushInfo(response?.Obs)
                }
                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap(response)
                }
                configProcedure?._pushProps({
                    IDAccountCreate: response.IDAccount
                })
            }
        ).catch(err => { toast.error("No se pudo realizar la accion"); console.log(err) })

    }

    const obsLength = response?.Obs?.trim()?.length ?? 0;
    const disableSelect = !response?.IDAccount || obsLength < 15;

    return (
        <div className="row">
            <div className="col-md-12">
                <AccountEditor idAccount={response.IDAccount} label="Tercero" onChange={(e) => { setResponse(e) }} canCreate />
            </div>
            <div className="col-md-12">
                <label>Observaciones</label>
                <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
            </div>
            <div className="col-md-12">
                <BasicButton
                    useMargin
                    eventClick={() => {
                        if (obsLength >= 15) {
                            onExportMap();
                        } else {
                            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
                        }
                    }}
                    icon="ri-send-plane-line"
                    disable={disableSelect}
                >
                    Seleccionar
                </BasicButton>
            </div>
        </div>
    )
}